import { render, staticRenderFns } from "./OwnCustomSelectOption.vue?vue&type=template&id=2bee6f86&"
import script from "./OwnCustomSelectOption.vue?vue&type=script&lang=js&"
export * from "./OwnCustomSelectOption.vue?vue&type=script&lang=js&"
import style0 from "./OwnCustomSelectOption.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports